<template>
  <page-content v-has-permission="'actions_view'">

    <panel ref="searchFormPanel" :is-open.sync="showFormSearch" show-close show-collapse title="Thông tin tìm kiếm">
      <c-form ref="searchForm" @submit="search()">

        <b-row>
          <c-input v-model.trim="searchForm.code" form-group-class="col-md-6 col-sm-6" label="Code"/>
          <c-input v-model.trim="searchForm.description" form-group-class="col-md-6 col-sm-6" label="Mô tả"/>
        </b-row>

        <b-row>
          <b-col class="text-center">
            <button class="btn btn-success" type="submit">
              <i class="fas fa-search"></i> Tìm kiếm
            </button>
            <button class="btn btn-secondary" type="reset" @click="resetFormSearch()">
              <i class="fas fa-redo-alt"></i>
              Xóa bộ lọc
            </button>
          </b-col>
        </b-row>
      </c-form>
    </panel>

    <panel ref="panel" show-collapse title="Danh sách hành động">
      <template #btn>
        <li>
          <a v-b-tooltip.hover title="Load lại dữ liệu" @click="$refs.table.reload()">
            <i class="fas fa-sync-alt"></i>
          </a>
        </li>
        <li>
          <a v-b-tooltip.hover title="Hiển thị thông tin tìm kiếm" @click="showFormSearch = !showFormSearch">
            <i class="fas fa-search"></i>
          </a>
        </li>
      </template>
      <c-table ref="table"
               :data-filter="searchForm"
               :header-configs="[
                   {text: '#', width: '50px'},
                   {text: 'Mã hành động', sortField:'code', sortable: true},
                   {text: 'Mô tả', sortField:'description', sortable: true},
                   {text: 'Người tạo', sortField:'createdBy', sortable: true},
                   {text: 'Thời gian tạo', sortField:'createdAt', sortable: true},
                   {text: 'Người sửa', sortField:'updatedBy', sortable: true},
                   {text: 'Thời gian cập nhật', sortField:'updatedAt', sortable: true},
                   {text: 'Thao tác', width: '150px'},
               ]"
               uri="/cms/api/v1.0/admin/actions/get-all"
      >
        <template #button>
          <b-button  v-if="hasPermission('actions_create')"
                    size="sm"
                    variant="success"
                    @click="$refs.formCreate.open()"
          >
            <i class="fas fa-plus-circle"></i> Thêm mới
          </b-button>
        </template>
        <template #default="{item, index}">
          <td class="text-right">{{ index }}</td>
          <td>{{ item.code }}</td>
          <td>{{ item.description }}</td>
          <td>{{ item.createdBy }}</td>
          <td>{{ item.createdAt | datetime }}</td>
          <td>{{ item.updatedBy }}</td>
          <td>{{ item.updatedAt | datetime }}</td>
          <td class="text-center">
            <b-button
                v-if="hasPermission('actions_update')"
                class="btn btn-icon"
                title="Sửa"
                type="button"
                variant="warning"
                @click="update(item)"
            >
              <i class="fas fa-pencil"></i>
            </b-button>

            <b-button
                v-if="hasPermission('actions_delete')"
                class="btn btn-icon"
                title="Xóa"
                type="button"
                variant="danger"
                @click="deleteItem(item)"
            >
              <i class="far fa-trash-alt"></i>
            </b-button>
          </td>
        </template>
      </c-table>
    </panel>

    <add ref="formCreate" @success="search()"/>
    <update ref="formUpdate" @success="search()"/>
    <delete ref="deleteConfirmDialog" @success="search()"/>
  </page-content>
</template>

<script>
import Add from './Add';
import Update from './Update';
import Delete from './Delete';

export default {
  name: "Index",
  components: {
    Add,
    Update,
    Delete,
  },
  data() {
    return {
      searchForm: {
        code: null,
        description: null
      },
      showFormSearch: false
    }
  },
  methods: {
    search() {
      this.$refs.table.reload();
    },
    resetFormSearch() {
      this.searchForm.code = null;
      this.searchForm.description = null;
      this.searchForm.status = null;

      this.search();
    },
    update(item) {
      this.$refs.formUpdate.open(item.id);
    },
    deleteItem(item) {
      this.$refs.deleteConfirmDialog.open(item);
    }
  }
}
</script>

<style scoped>

</style>